/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
  withStyles,
} from '@material-ui/core'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import ArrowBack from '@material-ui/icons/ArrowBackIos'
import classNames from 'classnames'
import NoteAddIcon from '@material-ui/icons/NoteAdd'

import styles from '../../../resources/theme/global'
import { dateFormatedFullDate, exportFormatedMoney } from '../../../util/utils'
import { details, late, makeReport } from '../HomeActions'

import Filter, { DetailsFilter } from './DetailsFilter'
import BaseRelatoryPage from '../../../components/hooks/BaseRelatoryPage'
import Icon from '@mdi/react'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import colors from '../../../assets/colors'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import DetailsTable from './DetailsTable'
import queryString from 'query-string'
import BaseCreatePage from '../../../components/hooks/BaseCreatePage'

const useStyles = makeStyles({
  pageLink: {
    width: 'auto',
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
  page: {
    fontSize: '14px',
    color: colors.textGray,
    fontWeight: 'normal',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
  },
  path: {
    fontSize: '20px',
    color: colors.primary,
    fontWeight: '700',
    position: 'relative',
  },
  btnReturn: {
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    padding: '4px',
    fontSize: '14px',
    color: colors.gray,
    backgroundColor: 'transparent',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      color: colors.primary,
      backgroundColor: 'inherit',
    },
  },
})

function Details(props) {
  const items = useSelector(state => state.dashboard.details)

  const dispatch = useDispatch()

  const { match, classes, location } = props

  const [modalOpen, setModalOpen] = useState(false)

  const handleToggleColumnsModal = () => {
    setModalOpen(!modalOpen)
  }

  useEffect(() => {
    dispatch(details(match.params.id, {}))
  }, [])

  return (
    <BaseCreatePage
      page={'Detalhes'}
      path={`Itens ${items[0]?.status?.name || ''}`}
      hiddenReturn
      goBack
    >
      <Grid item xs="12">
        <Grid container spacing={4}>
          <Grid item xs="12">
            <DetailsFilter
              detailsId={match.params.id}
              toggleColumnsModal={handleToggleColumnsModal}
            />
          </Grid>

          <Grid item xs="12">
            <DetailsTable
              data={items}
              open={modalOpen}
              toggleColumnsModal={handleToggleColumnsModal}
            />
          </Grid>
        </Grid>
      </Grid>
    </BaseCreatePage>
  )
}

export default withStyles(styles)(Details)
